import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import type { AppMenu } from '@modules/sidebar/utils';
import { AppModule } from '@modules/core/plugins/AppModule';
import { useI18n } from '@modules/i18n/composables';
import { ADMIN_PARTNERSHIP_MENU_ITEM, TRANSLATION_GROUP_SIDEBAR } from '@modules/sidebar/constants';

import {
  AFFILIATE_PROGRAM_ADMIN_FEES_PERMISSIONS,
  AFFILIATE_PROGRAM_ADMIN_FEES_ROUTE_NAME,
  TRANSLATION_GROUP_AFFILIATE_PROGRAM_ADMIN_FEES,
} from './constants';
import { getTranslationKeys } from './translations';

export class AdminFeesSettingsModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addAdminRoute({
      name: AFFILIATE_PROGRAM_ADMIN_FEES_ROUTE_NAME,
      path: 'fees',
      permission: AFFILIATE_PROGRAM_ADMIN_FEES_PERMISSIONS.SHOW,
      component: () => import('./pages/AdminFeesSettingsPage/AdminFeesSettingsPage.vue'),
    });
  }

  addMenu(menu: AppMenu): void {
    const { getTPath } = useI18n();

    menu.addChildAdminMenuItem(ADMIN_PARTNERSHIP_MENU_ITEM, {
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'ADMIN_PARTNERSHIP_ADMIN_FEES'),
      to: {
        name: AFFILIATE_PROGRAM_ADMIN_FEES_ROUTE_NAME,
      },
      permission: AFFILIATE_PROGRAM_ADMIN_FEES_PERMISSIONS.SHOW,
      id: AFFILIATE_PROGRAM_ADMIN_FEES_ROUTE_NAME,
      order: 25,
    });
  }

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_AFFILIATE_PROGRAM_ADMIN_FEES, getTranslationKeys);
  }
}
